import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, IconButton } from "@mui/material";
import React from "react";

// The width of the control, and of the space a row without one keeps so
// that its first cell lines up with the others
export const TOGGLE_WIDTH = 18;

export interface RowToggleProps {
  open: boolean;
  // What the control does, for a screen reader ("Expand")
  label: string;
  onToggle: () => void;
}

/**
 * The control that opens and closes what is beneath a row, the same in
 * every table of a detail view: a chevron that turns down when open.
 */
const RowToggle: React.FC<RowToggleProps> = ({ open, label, onToggle }) => (
  <IconButton
    size="small"
    aria-label={label}
    aria-expanded={open}
    onClick={onToggle}
    sx={{ p: 0, width: TOGGLE_WIDTH, height: 20, color: "text.secondary" }}
  >
    <ChevronRightIcon
      sx={{
        fontSize: 18,
        transform: open ? "rotate(90deg)" : "none",
        transition: "transform 120ms",
      }}
    />
  </IconButton>
);

// The space of a toggle in a row that has nothing to open
export const NoToggle: React.FC = () => (
  <Box sx={{ width: TOGGLE_WIDTH, flexShrink: 0 }} />
);

export default RowToggle;
